export default __webpack_public_path__ + "static/media/ecommerce.491c3fde.png";